import React from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const MissionVision = () => {
  return (
    <div className="mission-vision-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="mission-vision-content">
              <h1 className="page-title">Misyon, Vizyon ve Temel Değerler</h1>
              
              <div className="mission-section">
                <div className="section-card">
                  <h2>Misyonumuz</h2>
                  <p>
                    Yüzyılın yerel yönetim anlayışına uygun bir şekilde, şehrimizin daha yaşanılır kılınması için belediyecilik hizmetlerini kurumsal bir anlayışla mükemmelleştirerek sosyal belediyeciliğin imkân ve kabiliyetlerini verimli bir şekilde kullanan, kültürel ve etnik kimliğinin yaşadığı bir şehir olmak
                  </p>
                </div>
              </div>

              <div className="vision-section">
                <div className="section-card">
                  <h2>Vizyonumuz</h2>
                  <p>
                    İskenderun için sürdürülebilir ve yenilenen çözümlerle sosyal belediyecilik anlayışına uygun, medeni değerlerin yüksek olduğu, yaşanılabilir şehrin yerel yönetimi.
                  </p>
                </div>
              </div>

              <div className="values-section">
                <div className="section-card">
                  <h2>Temel Değerlerimiz</h2>
                  <div className="values-slogan">
                    
                  </div>
                  <ul className="values-list">
                    <li>
                      <span className="value-item">Temiz</span>
                    </li>
                    <li>
                      <span className="value-item">Dürüst</span>
                    </li>
                    <li>
                      <span className="value-item">Memnuniyet odaklı</span>
                    </li>
                    <li>
                      <span className="value-item">Şeffaf</span>
                    </li>
                    <li>
                      <span className="value-item">Çevreye duyarlı</span>
                    </li>
                    <li>
                      <span className="value-item">İnsan odaklı</span>
                    </li>
                  </ul>
                  <p className="values-footer">
                    Sosyal belediyecilik hizmet anlayışıyla hareket etmek.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVision;
